import React, { FC, JSX } from "react";
import classNames from "classnames";
import { useTranslations } from "next-intl";

type TProps = {
  item: {
    icon: JSX.Element;
    label: string;
    bgColor: string;
  };
  showBorder?: boolean;
  onClick: () => void;
};

const ActionItem: FC<TProps> = ({
  item: { icon, label, bgColor },
  showBorder,
  onClick,
}) => {
  const t = useTranslations();
  return (
    <li
      className={classNames("flex items-center gap-2 py-2 text-xs", {
        "border-b border-[#f9f9f9]": !!showBorder,
      })}
      onClick={onClick}
    >
      <span
        className={classNames(
          "flex items-center justify-center gap-2 rounded-full p-2",
          {
            [bgColor]: bgColor,
          },
        )}
      >
        {icon}
      </span>
      {t(label)}
    </li>
  );
};

export { ActionItem };
